<section class="min-h-screen px-3 pb-8 pt-5 sm:px-5 lg:px-8">
  <div class="mx-auto max-w-[1600px]">

    <!-- Page header -->
    <div class="mb-5 flex items-center gap-3">
      <div class="flex h-10 w-10 items-center justify-center rounded-full bg-[#FFD4E0] text-[#D31148]">
        <svg class="h-5 w-5" viewBox="0 0 24 24" fill="currentColor">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M12 1.5C12.1276 1.5 12.2537 1.52735 12.3697 1.58017L19.8697 5.00517C20.1798 5.14622 20.3846 5.4478 20.3986 5.78814C20.4681 7.47737 20.4041 11.3211 19.1035 14.8459C17.7909 18.4033 15.2265 21.6248 12.3072 22.9309C12.1116 23.019 11.8884 23.019 11.6928 22.9309C8.77352 21.6248 6.20906 18.4033 4.8965 14.8459C3.59586 11.3211 3.53191 7.47737 3.60138 5.78814C3.6154 5.4478 3.82024 5.14622 4.13029 5.00517L11.6303 1.58017C11.7463 1.52735 11.8724 1.5 12 1.5ZM5.09566 6.28936C5.03934 7.90855 5.13389 11.2751 6.30563 14.4718C7.49766 17.724 9.72243 20.4644 12 21.5901C14.2776 20.4644 16.5023 17.724 17.6944 14.4718C18.8661 11.2751 18.9607 7.90855 18.9043 6.28936L12 3.13907L5.09566 6.28936ZM12 7.25C12.4142 7.25 12.75 7.58579 12.75 8V12.5C12.75 12.9142 12.4142 13.25 12 13.25C11.5858 13.25 11.25 12.9142 11.25 12.5V8C11.25 7.58579 11.5858 7.25 12 7.25ZM12 16.5C12.5523 16.5 13 16.0523 13 15.5C13 14.9477 12.5523 14.5 12 14.5C11.4477 14.5 11 14.9477 11 15.5C11 16.0523 11.4477 16.5 12 16.5Z" />
        </svg>
      </div>
      <div>
        <h1 class="text-xl font-bold text-gray-900">Privacy & Legal</h1>
        <p class="text-sm text-gray-500">Terms, privacy, cookies and community policies</p>
      </div>
    </div>

    <!-- Tabs -->
    <div class="mb-4 overflow-x-auto rounded-xl border border-[#e8e8e8] bg-white px-3">
      <div class="flex min-w-max items-center gap-6 sm:gap-8">
        <button type="button" *ngFor="let tab of tabs" (click)="setTab(tab.key)"
          class="border-b-2 py-3 text-sm font-medium transition-colors" [ngClass]="
            activeTab === tab.key
              ? 'border-[#D31148] text-[#D31148]'
              : 'border-transparent text-gray-500 hover:text-gray-700'
          ">
          {{ tab.label }}
        </button>
      </div>
    </div>

    <!-- Tab content — reuses the same standalone legal pages, so the design matches exactly.
         No overflow-hidden here: it would clip/break the embedded page's sticky "On this page" TOC. -->
    <div class="rounded-xl border border-gray-200 dark:border-gray-800">
      <app-terms-of-service *ngIf="activeTab === 'terms'" />
      <app-privacy-policy *ngIf="activeTab === 'privacy'" />
      <app-cookie-policy *ngIf="activeTab === 'cookies'" />
      <app-community-guidelines *ngIf="activeTab === 'community'" />
      <app-age-verification-policy *ngIf="activeTab === 'age-verification'" />
    </div>

  </div>
</section>
